<template>
  <ConfigurationLayout>
    <template #headerBar>
      <HeaderBar
        v-if="route.name === 'organisationConfiguration'"
        class="hide-for-medium"
        :modifiers="['dark', 'padding-y-medium']"
      >
        <router-link
          :aria-label="$t('general.back')"
          class="header-bar__title header-bar__title--full-width typo-nav-item"
          :to="{ name: 'operations' }"
        >
          <UseSvg
            class="icon"
            name="arrow_left"
          />
          <div class="typo-small-title text-center">
            {{ $t('nav.configuration') }}
          </div>
        </router-link>
      </HeaderBar>

      <HeaderBar
        class="show-for-medium"
        :modifiers="['transparent', 'more-padding', 'more-height']"
      >
        <router-link
          class="button button--margin-right"
          :to="{ name: 'operations' }"
        >
          <LeftArrow class="icon" />
        </router-link>
        <p class="header-nav__title typo-ignore">
          {{ $t('nav.configuration') }}
        </p>
      </HeaderBar>
    </template>
    <template #panelContent>
      <component :is="currentComponentName" />
    </template>
  </ConfigurationLayout>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Components
import HeaderBar from '@/components/generic/header_bar.vue';
import ConfigurationLayout from '@/components/organisations/configuration/configuration_layout.vue';
import ConfigurationOrganisation from '@/components/organisations/configuration/configuration_organisation.vue';
import ConfigurationMine from '@/components/organisations/configuration/configuration_mine.vue';
import ConfigurationProcess from '@/components/organisations/configuration/configuration_process.vue';
import ConfigurationType from '@/components/organisations/configuration/configuration_type.vue';

// Icons
import UseSvg from '@/components/generic/use_svg.vue';
import LeftArrow from '@/images/arrow-left.svg';

defineProps({
  organisationId: { type: String, required: true },
});

const route = useRoute();

/**
 * Display correct panel component
 */
const currentComponentName = computed(() => {
  const condition = ['/mines', '/processes', '/types'];
  const currentRoute = condition.find((url) => route.path.includes(url));

  switch (currentRoute) {
    case condition[0]:
      return ConfigurationMine;

    case condition[1]:
      return ConfigurationProcess;

    case condition[2]:
      return ConfigurationType;

    default:
      return ConfigurationOrganisation;
  }
});
</script>
